import { createSelector } from '@ngrx/store';
import * as FNAPlanState from '../employee-detail.reducer';
import * as FNAReducer from '../reducers/fna.reducer';

export const getFNA = createSelector(FNAPlanState.getFNAState, FNAReducer.getFNA);
